export const PROFILE_INFO_WIDGET_NOTES_CLAMPING_LINES_COUNT = 3
